import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas, Button } from "react-bootstrap";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      <Offcanvas.Header className="border-bottom px-4">
        <Offcanvas.Title className="custom-cart-title">
          YOUR BAG
        </Offcanvas.Title>
        <span
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
        />
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column px-4">
        {cartItems && cartItems.length ? (
          <>
            <div>
              {cartItems && cartItems.length > 0 && (
                <div className="custom-cart-items-wrapper">
                  {cartItems.map((item, index) => (
                    <CartItems key={item._id || index} item={item} />
                  ))}
                </div>
              )}
            </div>

            <div className="custom-cart-footer mt-auto pt-3">
              <div className="d-flex justify-content-between total-row">
                <span className="total-label">SUBTOTAL:</span>
                <span className="total-price">₹{cartSummary.subtotal}</span>
              </div>
              
              {cartSummary.shipping > 0 && (
                <div className="d-flex justify-content-between total-row">
                  <span className="total-label">SHIPPING:</span>
                  <span className="total-price">+₹{cartSummary.shipping}</span>
                </div>
              )}

              {cartSummary.discount > 0 && (
                <div className="d-flex justify-content-between total-row">
                  <span className="total-label">COUPON DISCOUNT:</span>
                  <span className="total-price">-₹{cartSummary.discount}</span>
                </div>
              )}

              <div className="d-flex justify-content-between total-row">
                <span className="total-label">TOTAL:</span>
                <span className="total-price">₹{cartSummary.total}</span>
              </div>

              <Link
                to="/cart"
                className="go-to-cart-btn mt-3 text-center d-block"
              >
                GO TO CART
              </Link>
            </div>
          </>
        ) : (
          <div className="tf-mini-cart-wrap-blank">
            <div className="emptycart">
              <span>Your Shopping Cart is Empty</span>
            </div>

            <Link
              to="/shop"
              className="mt-3 tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center text-decoration-none text-white align-items-center"
              
            >
              Shop Now
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;
